import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ThreeSlotWorking from "./components/ThreeSlotWorking";
import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import ThreeSlotMachineDetailCard from "./components/ThreeSlotMachineDetailCard";
import { DUMMY_LOTTERIES } from "./ThreeSlotLottery";
// import slotInstance from "../../../Service/slotInstance";
// import web3 from "../../../Service/web3";
import NavBar from "../../../Components/NavBar";
import { colors } from "../../../../theme";

const ThreeSlotLotteryDetails = () => {
  const { id } = useParams();
  const history = useHistory();

  const [account, setAccount] = useState("");
  const [isCheckingWallet, setIsCheckingWallet] = useState(true);

  // User-specific values.
  const [balance, setBalance] = useState("0.00");
  const [win, setWin] = useState("0.00");

  // Find the lottery using the ID from the URL or contract
  const [lotteryData] = useState(() =>
    DUMMY_LOTTERIES.find((lottery) => lottery.lotteryId.toString() === id)
  );

  /*
  useEffect(() => {
    const fetchGameDetails = async () => {
      try {
        if (!slotInstance?.methods?.slotGames) return;
        const g = await slotInstance.methods.slotGames(id).call();
        if (g && (String(g.reels) === "3" || Number(g.reels) === 3)) {
          const minBetFormatted = web3?.utils?.fromWei ? web3.utils.fromWei(String(g.minBet || "0"), "ether") : "1.00";
          const maxBetFormatted = web3?.utils?.fromWei ? web3.utils.fromWei(String(g.maxBet || "0"), "ether") : "100.00";
          const numericMax = parseFloat(maxBetFormatted) || 100;
          const numericMin = parseFloat(minBetFormatted) || 1;

          setLotteryData({
            lotteryId: Number(g.gameId || id),
            name: `3-SlotBET #${g.gameId || id}`,
            creator: g.owner ? `${g.owner.slice(0, 6)}...${g.owner.slice(-4)}` : "AutoBET Creator",
            owner: g.owner,
            active: g.active,
            minBet: minBetFormatted,
            maxBet: maxBetFormatted,
            jackpots: {
              mini: {
                amount: (numericMax * 0.15).toFixed(2),
                seedValue: (numericMax * 0.1).toFixed(2),
                contributionPerSpin: (numericMin * 0.02).toFixed(3),
              },
              major: {
                amount: (numericMax * 0.45).toFixed(2),
                seedValue: (numericMax * 0.3).toFixed(2),
                contributionPerSpin: (numericMin * 0.008).toFixed(3),
              },
              mega: {
                amount: (numericMax * 1.2).toFixed(2),
                seedValue: (numericMax * 0.6).toFixed(2),
                contributionPerSpin: (numericMin * 0.002).toFixed(3),
              },
            },
          });
        }
      } catch (err) {
        console.warn("Could not fetch slot game by ID from contract:", err);
      }
    };

    if (id) {
      fetchGameDetails();
    }
  }, [id]);
  */

  //  Check whether a wallet is already connected.
  useEffect(() => {
    const checkWalletConnection = async () => {
      if (!window.ethereum) {
        setIsCheckingWallet(false);
        return;
      }

      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        });

        if (accounts && accounts.length > 0) {
          setAccount(accounts[0]);
        }
      } catch (error) {
        console.error("Failed to check wallet connection:", error);
      } finally {
        setIsCheckingWallet(false);
      }
    };

    checkWalletConnection();
  }, []);

  //  Listen for wallet changes.
  useEffect(() => {
    if (!window.ethereum) return;

    const handleAccountsChanged = (accounts) => {
      setAccount(accounts?.[0] || "");
    };

    window.ethereum.on("accountsChanged", handleAccountsChanged);

    return () => {
      window.ethereum.removeListener(
        "accountsChanged",
        handleAccountsChanged
      );
    };
  }, []);

  // Wallet is not connected.
  // Do not render the game card.
  if (!isCheckingWallet && !account) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 800,
                color: "#0f172a",
                mb: 1,
              }}
            >
              Please Connect Your Wallet
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "#64748b",
              }}
            >
              Connect your wallet to access this lottery.
            </Typography>
          </Box>
        </Box>
      </Container>
    );
  }

  // Still checking wallet.
  if (isCheckingWallet) {
    return null;
  }

  // Lottery ID does not exist.
  if (!lotteryData) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
            }}
          >
            Lottery Not Found
          </Typography>
        </Box>
      </Container>
    );
  }

  // Render the actual playable card only when:
  // 1. Wallet is connected
  // 2. Lottery exists
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: colors.dashboard.canvas,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />
      <Container
        maxWidth="xl"
        sx={{
          pt: { xs: "96px", sm: "108px", md: "116px" },
          pb: { xs: 4, md: 8 },
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.goBack()}
            sx={{
              color: colors.slate[600],
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.95rem",
              px: 0,
              "&:hover": {
                bgcolor: "transparent",
                color: colors.primary.main,
              },
            }}
          >
            Back to Arena
          </Button>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
          <Box sx={{ width: "100%", maxWidth: "md" }}>
            <ThreeSlotMachineDetailCard
              lotteryData={lotteryData}
              account={account}
              balance={balance}
              win={win}
              setBalance={setBalance}
              setWin={setWin}
            />
          </Box>
        </Box>

        <ThreeSlotWorking />
      </Container>
    </Box>
  );
};

export default ThreeSlotLotteryDetails;